angular.module('picmonicng').directive('plsPicmonic', [
  function () {
    return {
      restrict: 'E',
      scope: {
        picmonic: '=',
        track: '=',
        scrollToType: '=',
        scrollToId: '=',
      },
      templateUrl: '/templates/directives/pls-picmonic.html',
      controller: [
        '$scope',
        'UserService',
        'LearnService',
        'Tracks',
        'MarketOptionsConfig',
        '$stateParams',
        '$state',
        '$timeout',
        'BrowseService',
        'QuizService',
        function (
          $scope,
          UserService,
          LearnService,
          Tracks,
          MarketOptionsConfig,
          $stateParams,
          $state,
          $timeout,
          BrowseService,
          QuizService
        ) {
          $scope.LearnService = LearnService;
          $scope.BrowseService = BrowseService;
          $scope.QuizService = QuizService;
          $scope.$state = $state;

          $scope.openPicmonic = function () {
            window.open('/learn/' + $scope.picmonic.slug);
          };

          $scope.goToPicmonic = function (event, track_id, card) {
            if (UserService.user.user_id) {
              if (UserService.user.current_track_id != track_id) {
                UserService.user.current_track_id = track_id;
                UserService.user.$update();
              }

              send_ga('event', 'Pathways', 'Start Learning');
              $scope.track.last_viewed_card_id = card.card_id;
              Tracks.updatev3({
                last_viewed_card_id: card.card_id,
                track_id: track_id,
              });

              $state.go('app.learn', { slug: card.slug });
            } else {
              $cookies.put('pls_user_track_id', track_id);

              send_ga('event', 'Pathways', 'No Account Modal');

              $modal.open({
                templateUrl: '/templates/modals/register-modal.html',
                windowClass: 'registration-cta-modal full-screen-modal',
                backdropClass: 'below-nav modal-body-reduced',
                scope: $scope,
                backdrop: 'static',
                controller: 'RegisterModalController',
                resolve: {
                  card: function () {
                    return card;
                  },
                  market_id: function () {
                    return MarketOptionsConfig.getMarketBySlug($stateParams.market).id;
                  },
                  copy: function () {
                    return null;
                  },
                  redirect: function () {
                    return null;
                  },
                  extraParams: function () {
                    return null;
                  },
                },
              });
            }
          };
        },
      ],
    };
  },
]);
